// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__17Axy","cell":"ColumnAccessor_cell__3adsA","firstCellAccent":"ColumnAccessor_firstCellAccent__2v-kz"};